import { Button, styled } from '@mui/material';

export const AssignHepActionWrapper = styled('div')(({ theme }) => ({}));

export const AssignHepActionButton = styled(Button)(({ theme }) => ({
    margin: '0 auto',
}));
